<template>
  <div class="cashflow-type-mock-income">
    <div class="title">
      <span>הכנסות</span>
    </div>

    <expense-progress :recommended-or-expected-label="'נכנס עד עכשיו'"
                      :up-to-now-label="'סה״כ צפוי להיכנס'"
                      :pending="true" />

    <mock-sections-label :title="'פירוט הכנסות קבועות'" />
    <mock-sections-label :title="'פירוט הכנסות משתנות'" />
  </div>
</template>

<script>
import ExpenseProgress from '../../../generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue';
import CashflowAnalytics from '../../../generic-components/CashflowAnalytics.vue';
import MockSectionsLabel from './MockSectionsLabel.vue';

export default {
  name: 'CashflowTypeMockIncome',
  mixins: [CashflowAnalytics],
  components: {
    ExpenseProgress,
    MockSectionsLabel,
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../scss/mixins';

  .cashflow-type-mock-income {
    @include cashflow-card;
    margin-bottom: 16px;
    color: $riseup_gray_1;
    border-radius: 3px;
    border: dashed 1px $riseup_gray_1;

    .title {
      color: $riseup_gray_1;
      @include cashflow-card-title;
    }

    .cashflow-type-color {
      color: $riseup_gray_1;
    }

    .cashflow-type-background-color {
      background-color: $riseup_gray_0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/pending-month/components/types/CashflowTypeMockIncome.vue